let nativeShareFailed = false;

const isNativeShareSupported = () => {
  return !nativeShareFailed && !!window.navigator.share;
};

const nativeShare = (data) => {
  return new Promise((resolve, reject) => {
    navigator
      .share(data)
      .then(resolve)
      .catch((e) => {
        if (!(e instanceof DOMException) || e.code !== 20) {
          console.error("Native share failed", e); // eslint-disable-line
          nativeShareFailed = true;
        }
        reject(e);
      });
  }).catch((e) => {
    if (e.name === "AbortError") {
      return false;
    }

    throw e;
  });
};

export { isNativeShareSupported, nativeShare };
